import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { isSessionSet, getIsArtist, getUserID } from 'selectors/user/session'
import { getArtistInfo } from '../selectors/artist'
import {
  getArtworkCategory,
  getArtworkId,
  getArtworkMediums,
  getArtworkStyles,
  getArtworkSubject,
} from '../selectors/artwork'
import { getArtistSeeMore, getRelatedSeeMore } from '../selectors/carousel'
import { getSelectedProductSku, getSelectedProductStatus } from '../selectors/product'
import { getVisiiMetadata } from '../selectors/general'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { getIndice } from 'selectors/algolia'

const mapStateToProps = createStructuredSelector({
  artistInfo: getArtistInfo,
  artistSeeMore: getArtistSeeMore,
  artworkId: getArtworkId,
  category: getArtworkCategory,
  hasSession: isSessionSet,
  isArtist: getIsArtist,
  mediums: getArtworkMediums,
  productStatus: getSelectedProductStatus,
  relatedSeeMore: getRelatedSeeMore,
  sku: getSelectedProductSku,
  styles: getArtworkStyles,
  subject: getArtworkSubject,
  visiiMetadata: getVisiiMetadata,
  algoliaUserToken: getAlgoliaUserToken,
  userID: getUserID,
  algoliaSearchIndex: getIndice,
})

export type ConnectorProps = {
  artistInfo: Record<string, any>
  artistSeeMore: Record<string, any>
  artworkId: string
  category: string
  currentArtwork: string
  hasSession: boolean
  isArtist: boolean
  mediums: Array<string>
  productStatus: string
  relatedSeeMore: Record<string, any>
  sku: string
  styles: Array<string>
  subject: string
  visiiMetadata: Record<string, any> | null | undefined
  algoliaUserToken: string
  userID: number
  algoliaSearchIndex: string
}

export default connect(mapStateToProps)
